import { render, staticRenderFns } from "./NewComposer.vue?vue&type=template&id=1c328202&scoped=true&"
import script from "./NewComposer.vue?vue&type=script&lang=js&"
export * from "./NewComposer.vue?vue&type=script&lang=js&"
import style0 from "./NewComposer.vue?vue&type=style&index=0&id=1c328202&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c328202",
  null
  
)

export default component.exports